var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('eider-data-table',{attrs:{"headers":_vm.headers,"title":_vm.$t('configs.configs'),"endpoint":"configs","ref-form":"configsForm","delete-endpoint":_vm.deleteEndpoint}})}
var staticRenderFns = []

export { render, staticRenderFns }